import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { updateProfileLanguage } from "../../../clients/profile.client";
import { LANG_KEY } from "../../../i18next";
import { changeProfile } from "../../../reducers/auth.reducer";
import styles from "./language.switcher.module.css";

const LanguageSwitcher = ({ showLabel = true, variant = "header" }) => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const { tokenValue, user } = useSelector((state) => state.auth);

  const changeLanguage = async (event) => {
    const language = event.target.value;
    const previousLanguage = i18n.resolvedLanguage || i18n.language;

    localStorage.setItem(LANG_KEY, language);
    await i18n.changeLanguage(language);

    if (!user || !tokenValue) return;

    const response = await updateProfileLanguage(language, tokenValue);

    if (response.isError) {
      localStorage.setItem(LANG_KEY, previousLanguage);
      await i18n.changeLanguage(previousLanguage);
      return;
    }

    dispatch(changeProfile(response.data || { language }));
  };

  return (
    <label className={`${styles.container} ${variant === "profile" ? styles.profile : ""}`}>
      {showLabel && <span>{t("language.label")}</span>}
      <select
        aria-label={t("language.label")}
        value={i18n.resolvedLanguage || i18n.language}
        onChange={changeLanguage}
      >
        <option value="en">{t("language.english")}</option>
        <option value="ru">{t("language.russian")}</option>
        <option value="uk">{t("language.ukrainian")}</option>
      </select>
    </label>
  );
};

export default LanguageSwitcher;
